import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

import { START_TOUCH, TOUCH } from '@confluence/navdex/entry-points/NavdexPointType.ts';

export const fireCustomHomepageClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeName) => () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'customHomepage',
				attributes: {
					selectedItemPageContext: routeName,
					navigationLayer: 'global',
					navVersion: '3',
					navdexPointType: START_TOUCH,
				},
			},
		}).fire();
	};

export const fireHomeClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef) => () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'home',
				attributes: {
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navVersion: '3',
					navdexPointType: START_TOUCH,
				},
			},
		}).fire();
	};

export const fireRecentsClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef) => (isExpanded: boolean) => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'recents',
				attributes: {
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navVersion: '3',
					navdexPointType: START_TOUCH,
					status: isExpanded ? 'expanded' : 'collapsed',
				},
			},
		}).fire();
	};

export const fireSpacesClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef) => (isExpanded: boolean) => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'spaces',
				attributes: {
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navVersion: '3',
					navdexPointType: START_TOUCH,
					status: isExpanded ? 'expanded' : 'collapsed',
				},
			},
		}).fire();
	};

export const firePeopleClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef) => () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'peopleMenuDropdown',
				attributes: {
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navVersion: '3',
					navdexPointType: START_TOUCH,
				},
			},
		}).fire();
	};

export const fireAppsClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef) => (isExpanded: boolean) => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'apps',
				attributes: {
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navVersion: '3',
					navdexPointType: START_TOUCH,
					status: isExpanded ? 'expanded' : 'collapsed',
				},
			},
		}).fire();
	};

export const fireTemplatesClickedAnalytics =
	(createAnalyticsEvent: CreateUIAnalyticsEvent, routeDataRef) => () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'templates',
				attributes: {
					selectedItemPageContext: routeDataRef.current?.routeName,
					navigationLayer: 'global',
					navVersion: '3',
					navdexPointType: TOUCH,
				},
			},
		}).fire();
	};
